module.exports = __webpack_public_path__ + "img/default.a4c1fb27.png";